// src/hooks/useExportExcel.js
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const useExportExcel = () => {
  const exportToExcel = (data, fileName = 'export.xlsx') => {
    try {
      if (Array.isArray(data)) {
        // Tạo workbook
        const workbook = XLSX.utils.book_new();

        // Chuyển đổi data thành worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Thêm worksheet vào workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'baogia');

        // // Xuất file
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
      } else {
        XLSX.writeFile(data, `${fileName}.xlsx`);
      }
    } catch (error) {
      console.error('Export failed:', error);
    }
  };

  return { exportToExcel };
};
